var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10993_31192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.00001 4.63995C4.12492 4.76412 4.29389 4.83382 4.47001 4.83382C4.64614 4.83382 4.81511 4.76412 4.94001 4.63995L7.33335 2.21995V15.8333C7.33335 16.0101 7.40359 16.1797 7.52861 16.3047C7.65363 16.4297 7.8232 16.5 8.00001 16.5C8.17683 16.5 8.34639 16.4297 8.47142 16.3047C8.59644 16.1797 8.66668 16.0101 8.66668 15.8333V2.22662L11.08 4.63995C11.142 4.70244 11.2157 4.75204 11.297 4.78588C11.3782 4.81973 11.4653 4.83715 11.5533 4.83715C11.6414 4.83715 11.7285 4.81973 11.8097 4.78588C11.891 4.75204 11.9647 4.70244 12.0267 4.63995C12.1508 4.51505 12.2205 4.34608 12.2205 4.16995C12.2205 3.99383 12.1508 3.82486 12.0267 3.69995L9.42001 1.08662C9.04501 0.712081 8.53668 0.501709 8.00668 0.501709C7.47668 0.501709 6.96835 0.712081 6.59335 1.08662L4.00001 3.69995C3.87585 3.82486 3.80615 3.99383 3.80615 4.16995C3.80615 4.34608 3.87585 4.51505 4.00001 4.63995Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10993_31192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowWhite);
export default __webpack_public_path__ + "static/media/up_arrow_white.8cce145a1731c94b3d3661cb8949c416.svg";
export { ForwardRef as ReactComponent };